import React, { useEffect } from "react";
import { Main, Content } from "../../../components/Layout";

import { Row, Col } from "react-bootstrap";
import { NavLink } from "react-router-dom";

import styleButton from "../../../components/Button/Button.module.css";
import styleTab from "../../../components/Tab/Tab.module.css";
import Slct from "../../../components/Slct";
import CardSummary from "../../../components/Cards/Summary";

export default function NewBudget() {
  function handleResize() {
    var getDivs = document.getElementsByClassName("cardSummary");

    for (var i = 0; i < getDivs.length; i++) {
      getDivs[i].style.height = "auto";
    }

    var arrayLength = getDivs.length;
    var heights = [];

    for (let i = 0; i < arrayLength; i++) {
      heights.push(getDivs[i].offsetHeight);
    }

    function getHighest() {
      return Math.max(...heights);
    }

    var tallest = getHighest();

    for (let i = 0; i < getDivs.length; i++) {
      getDivs[i].style.height = tallest + "px";
    }
  }

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
  });

  return (
    <Main>
      <Content>
        <Row className="justify-content-between mb-5">
          <Col sm={3} className={styleTab.tab}>
            <NavLink to="/business/filter">Funil de Vendas</NavLink>
            <NavLink to="/business/summary">Progresso</NavLink>
          </Col>

          <Col sm={6} className="d-flex flex-row row-list">
            <div className="d-flex flex-grow-1">
              <Slct
                options={[
                  { value: "1", label: "Período" },
                  { value: "2", label: "Outro" },
                ]}
                name="city_id"
                placeholder="..."
                className="w-100"
              />
            </div>
            <button className={styleButton.button_clean}>Modelos</button>
            <button className={styleButton.button_ghost}>Exportar Relatório</button>
          </Col>
        </Row>
        <Row>
          <Col>
            <h2 class="page-title mb-3">Resumo do Progresso</h2>
          </Col>
        </Row>
        <Row className="card-container">
          <Col sm={4} className="d-flex">
            <CardSummary
              title="Contratos em Negociação"
              progressPercent="10"
              classes="10"
              compare="4"
              description="Número de negociações ativas no funil comercial do início do mês até a data atual."
            />
          </Col>
          <Col sm={4} className="d-flex">
            <CardSummary
              title="Contratos Ganhos"
              progressPercent="-10"
              classes="10"
              compare="4"
              description="Número de negociações que resultaram em fechamento positivo do início do mês até a data atual."
            />
          </Col>
          <Col sm={4} className="d-flex">
            <CardSummary
              title="Contratos Perdidos"
              progressPercent="-10"
              classes="10"
              compare="4"
              description="Número de negociações que resultaram em perda de contrato do início do mês até a data atual."
            />
          </Col>
          <Col sm={4} className="d-flex">
            <CardSummary
              title="Funil de Conversão"
              progressPercent="-10"
              classes="10"
              compare="4"
              description="Tempo médio que o contrato passa no funil até o seu fechamento."
            />
          </Col>
          <Col sm={4} className="d-flex">
            <CardSummary
              title="Tempo Médio de Fechamento"
              progressPercent="-10"
              classes="10"
              compare="4"
              description="Tempo médio que o contrato passa no funil até o seu fechamento."
            />
          </Col>
          <Col sm={4} className="d-flex">
            <CardSummary
              title="Formandos em Negociação"
              progressPercent="-10"
              classes="10"
              compare="4"
              description="Número de formandos únicos sendo negociados nos contratos atuais."
            />
          </Col>
        </Row>
      </Content>
    </Main>
  );
}
